import { useTranslation } from '../useTranslation';

export default function AirvoyActivateAndHow({
  imageUrl = "https://images.unsplash.com/photo-1542751110-97427bbecf20?q=80&w=1600&auto=format&fit=crop"
}) {
  const { t } = useTranslation(); // Add this line

  return (
    <section className="py-20 sm:px-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-24">

        {/* =============== Block 1: Activate once / Use everywhere =============== */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left visual */}
          <div className="relative">
            <div className="rounded-3xl bg-gray-100 overflow-hidden shadow-lg ring-1 ring-black/5">
              <img
                src={imageUrl}
                alt={t('activate.altText')}
                className="w-full h-[360px] sm:h-[420px] object-cover opacity-90"
              />
              {/* overlay chips to mimic screenshot */}
              <div className="absolute inset-0 p-6 sm:p-8 pointer-events-none">
                <div className="space-y-4 sm:space-y-6">
                  <div className="flex flex-wrap gap-3 sm:gap-4">
                    <span className="px-5 py-2 rounded-full bg-white/80 backdrop-blur text-gray-700 text-lg shadow">
                      {t('activate.activeInThailand')}
                    </span>
                    <span className="px-5 py-2 rounded-full bg-white/80 backdrop-blur text-gray-700 text-lg shadow">
                      {t('activate.activeInSpain')}
                    </span>
                  </div>
                  <div className="flex">
                    <span className="px-5 py-2 rounded-full bg-white backdrop-blur text-purple-600 text-xl font-semibold shadow inline-flex items-center gap-3">
                      <span className="w-3 h-3 rounded-full bg-green-500" />
                      {t('activate.activeWorldwide')}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-3 sm:gap-4">
                    <span className="px-5 py-2 rounded-full bg-white/80 backdrop-blur text-gray-700 text-lg shadow">
                      {t('activate.activeInGreece')}
                    </span>
                    <span className="px-5 py-2 rounded-full bg-white/80 backdrop-blur text-gray-700 text-lg shadow">
                      {t('activate.activeInMexico')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right copy */}
          <div>
            <div className="w-10 h-10 rounded-xl bg-purple-500/90 ring-8 ring-purple-500/10 mb-6 flex items-center justify-center text-white">
              ✓
            </div>

            <h3 className="text-3xl sm:text-4xl font-semibold text-gray-900 tracking-tight">
              {t('activate.title')}
            </h3>

            <p className="mt-6 text-lg leading-8 text-gray-600 max-w-xl">
              {t('activate.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}